import "es6-promise/auto";
import Vue from "vue";
import Axios from "axios";
import Common from "../../components/common.js";

Vue.component("common", Common);

new Vue({
  el: "#uz-taejung-work",
  data: function() {
    return {
      viewModel: {
        list: [],
        listYear: [],
        selectYear: ""
      }
    };
  },
  mounted: function() {
    let vm = this;
    try {
      vm.fnGetListYear();
      vm.fnGetList(vm.viewModel.selectYear);
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    fnGetList: function(item) {
      let vm = this;
      vm.viewModel.selectYear = item;
      Axios.post("/taejung/board/list", { bbsId: "TJ_PORTFOLIO", searchYear: vm.viewModel.selectYear, paramPage: "WORK" })
        .then(function(response) {
          let rs = response.data;
          vm.viewModel.list = rs.list;
        })
        .catch(function(ex) {
          console.log(ex);
        });
    },
    fnGetListYear: function() {
      let vm = this;
      Axios.post("/taejung/work/year/list", {})
        .then(function(response) {
          let rs = response.data;
          vm.viewModel.listYear = rs.listYear;
        })
        .catch(function(ex) {
          console.log(ex);
        });
    }
  }
});



// WEBPACK FOOTER //
// ./src/uz/taejung/taejung-work-controller.js